<template>
  <div class="sitemap-list_item droidSerif cursor-pointer" v-for="item in bottomChannels" :key="item.channelId" @click="openChannelPage(item)">
    {{ item.channelName }}
  </div>
  <Teleport to="#headerChannel">
    <NDropdown
      trigger="click"
      :z-index="5000"
      :to="dropdownEl"
      class="channel-header-tabs"
      :options="topChannels?.map(item => ({ key: item.channelId +'&'+ item.channelStrategy+'&'+item.pcStyle, label: item.channelName, ...item }))"
      label="channelName"
      @select="openTabsMenu"
    >
      <a class="header-channel" ref="dropdownEl" :alt="typeViteEnv('VITE_BASE_STATE_TITLE')">
        <img class="header-channel-icon" src="/resource/image/channel.svg" alt="channel">
      </a>
    </NDropdown>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, Teleport } from 'vue'
import { NDropdown } from 'naive-ui'
import { useStore } from '@gx-vuex'
import global from '@/common/global'
import { useUrlSearchParams } from '@vueuse/core'
import { getChannel } from '@/services/picDetails'
import { openChannel, handleChannelAlias } from '@/utils/util'
import { isBuild, typeViteEnv } from '@/utils/env'
import { cloneDeep } from 'lodash-unified'

document.querySelector('.header-channel-icon').classList.add('none')
document.querySelector('#headerChannel').classList.add('active')

const paramsUrls = useUrlSearchParams()

const dropdownEl = ref()
const store = useStore()
const allChannels = ref<ChannelList[]>([])
const topChannels = ref<ChannelList[]>([])
const bottomChannels = ref<ChannelList[]>([])

onMounted(async () => {
  if (paramsUrls.promote == 'true') {
    allChannels.value = global.allChannels
    topChannels.value = global.topChannels
    bottomChannels.value = global.bottomChannels
    return
  }
  const response: ResponseResult<{
    topChannels: ChannelList[];
    bottomChannels: ChannelList[];
    allChannels: ChannelList[];
  }> = await getChannel()
  
  if (response) {
    allChannels.value = response.data?.allChannels?.filter((item: {
      channelName: any;
    }) => item.channelName)
      ?.map(item => {
        item.channelAlias = handleChannelAlias(item.channelAlias || '')
        return item
      }) || global.allChannels
    
    store.global.setGlobalData({
      channelData: cloneDeep(allChannels.value)
    })
    
    topChannels.value = response.data?.topChannels?.filter((item: {
      channelName: any;
    }) => item.channelName)
      ?.map(item => {
        item.channelAlias = handleChannelAlias(item.channelAlias || '')
        return item
      }) || global.topChannels
    bottomChannels.value = response.data?.bottomChannels?.filter((item: {
      channelName: any;
    }) => item.channelName)
      ?.map(item => {
        item.channelAlias = handleChannelAlias(item.channelAlias || '')
        return item
      }) || global.bottomChannels
  }
})

const openChannelPage = (item: ChannelList) => {
  //pcStyle  	string必须    20230430;迭代三PC样式 1-全局4:3；2-全局16:9；
  //xi频道为3   pd series为4   brnn为5
  //-1为首页
  if (item.channelId === -1) {
    const link = `${import.meta.env.VITE_BASE_HOMEPAGE_URL}`
    window.open(link)
  } else {
    openChannel(item, true)
  }
}

const openTabsMenu = (val: any, item: ChannelList) => {
  if (item.channelId === -1) {
    window.open(location.origin)
    
    return
  }
  openChannel(item, true)
}
</script>

<style lang="less" scoped>
@import "./style";
</style>
